const debounce = (callback: () => void, delay: number): ((this: any) => void) => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      timeoutId = undefined;
      callback.apply(this, args);
    }, delay);
  };
};

export default debounce;
